import HackleDevTools from '@hackler/javascript-devtools';
import { HackleProvider as HackleProvider_, createInstance } from '@hackler/react-sdk';
import type { HackleReactSDKClient } from '@hackler/react-sdk/lib/client';
import Cookies from 'js-cookie';
import type { ReactNode } from 'react';
import { useRef } from 'react';

import { NEXT_PUBLIC_ENV } from '../../appConfig';
import useClientAccountProfileQuery from '../queries/useClientAccountProfileQuery';

export function HackleProvider({ children }: { children: ReactNode }) {
  const hackleClientRef = useRef<HackleReactSDKClient | null>(null);
  const { data: profile } = useClientAccountProfileQuery();

  const user = {
    id: Cookies.get('deviceId'),
    userId: String(profile?.id),
  };

  if (hackleClientRef.current === null) {
    const hackleOption = {
      exposureEventDedupIntervalMillis: 1_000,
      devTool: HackleDevTools,
      autoOpenDevTool: NEXT_PUBLIC_ENV === 'development',
    };

    hackleClientRef.current = createInstance(
      process.env.NEXT_PUBLIC_HACKLE_CLIENT_KEY || '',
      hackleOption,
    );
  }

  return (
    <HackleProvider_ hackleClient={hackleClientRef.current} user={user} supportSSR>
      {children}
    </HackleProvider_>
  );
}
